import {useQuery} from '@tanstack/react-query'

import {SHORT_LINK_HOST} from '#/lib/constants'
import {resolveShortLink} from '#/lib/link-meta/resolve-short-link'
import {parseStarterPackUri} from '#/lib/strings/starter-pack'
import {STALE} from '#/state/queries/index'

const ROOT_URI = `${SHORT_LINK_HOST}/`

const RQKEY_ROOT = 'resolved-short-link'
export const RQKEY = (code: string) => [RQKEY_ROOT, code]

export function useResolvedStarterPackShortLink({code}: {code: string}) {
  return useQuery({
    queryKey: RQKEY(code),
    queryFn: async () => {
      const uri = `${ROOT_URI}${code}`
      const res = await resolveShortLink(uri)
      return parseStarterPackUri(res)
    },
    // Transient failures (network blip, service restart) retry silently so
    // the short-link screen keeps its loader instead of flashing
    // "could not be found" and healing a second later.
    retry: failureCount => failureCount < 3,
    retryDelay: attempt => Math.min(400 * 2 ** attempt, 2000),
    enabled: Boolean(code),
    staleTime: STALE.HOURS.ONE,
  })
}
